import { getConfigName } from "@helpers/funciones";
import { WaitingRoom } from "./WaitingRoom";
import { WaitingRoomConcluida } from "./WaitingRoomConcluida";
import { WaitingRoomWuWei } from "./WaitingRoomWuWei";

const waitingRoomPorEmpresa: Record<string, React.FC> = {
  // Marketplace (Pymio): la solicitud queda en el marketplace para las financieras aliadas.
  market_place: WaitingRoomConcluida,
  // WuWei: análisis de la actividad del conductor.
  wuwei: WaitingRoomWuWei,
};

/**
 * Monta la sala de espera del tenant (ver `waitingRoomPorEmpresa`) o, si no tiene una propia, la
 * genérica `WaitingRoom`.
 */
export const WaitingRoomPorEmpresa = () => {
  const Component = waitingRoomPorEmpresa[getConfigName(window.location.href)] ?? WaitingRoom;
  return <Component />;
};
